<script lang="ts" setup>
import { getShopPermalink } from '~/lib'
import { useAutoHide } from './header/useAutoHide'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { header, transform } = useAutoHide()
const localePath = useLocalePath()
const checkoutPhoneNumber = computed(() => t('shop.checkoutHeader.phoneNumber'))
const checkoutHelpLabel = computed(() => `${t('shop.checkoutHeader.needHelp')} ${checkoutPhoneNumber.value}`)
</script>
<template>
  <header ref="header" class="header" :style="{ ['--transform']: `${transform}px` }">
    <nav class="box box-with-padding">
      <Logo />
      <div class="f-18 f-bold help">
        <a :href="`tel:${checkoutPhoneNumber}`">{{ checkoutHelpLabel }}</a>
      </div>
      <div>
        <ButtonBack :to="localePath(getShopPermalink())">{{ t('shop.checkoutHeader.toShop') }}</ButtonBack>
      </div>
    </nav>
  </header>
</template>
<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 99;

  transform: translateY(var(--transform));

  @include transitions(box-shadow);

  .is-scrolled & {
    box-shadow: var(--shadow-light-bottom);
  }

  nav {
    position: relative;
    height: var(--header-bar-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    --mobile-icon-width: 44px;
    .help {
      display: none;
      @include breakpoint(ds) {
        display: block;
      }
      a {
        text-decoration: none;
      }
    }

    :deep(.back) {
      padding: 0;
    }
  }
}
</style>
